import { Component } from "@angular/core";

@Component({
    selector: 'app-skeleton-list-item',
    template: `
        <div class="skeleton-item list-group-item ps-4 pt-3 pe-3 pb-4">
            <div class="d-flex w-100 align-items-center justify-content-between">
                <div class="skeleton-header skeleton-animate"></div>
                <div class="skeleton-icon skeleton-animate"></div>
            </div>
            <div class="col pb-2">
                <div class="skeleton-badge skeleton-animate"></div>
            </div>
            <div class="col m-0">
                <div class="skeleton-text skeleton-animate"></div>
            </div>
            <div class="col m-0">
                <div class="skeleton-text skeleton-animate" style="width: 70%;"></div>
            </div>
            <div class="col m-0">
                <div class="skeleton-text skeleton-animate" style="width: 60%;"></div>
            </div>
        </div>
    `,
    styleUrls: ['./skeleton-list-item.component.scss']
})
export class SkeletonItemListComponent {}